function useBackgroundJobCard (backgroundJobMetadata,
  bgJobSubmitProgressType,
  activateSubmitProgress,
  currentSubmitProgress) {
  const targetJob = backgroundJobMetadata.find(x => (x.data || {}).submitProgress === bgJobSubmitProgressType)

  let cardColor = ''
  let bgJobCanStart = false
  let status = 'notStarted'
  let message = ''
  let icon = ''
  let hasError = false
  const { backgroundJobMessages } = targetJob || {}

  if (targetJob) {
    message = targetJob.message
    switch (targetJob.status) {
      case 0:
        cardColor = 'primary'
        status = 'active'
        break
      case 1:
        cardColor = 'success'
        status = 'finished'
        break
      case 3:
        cardColor = 'success'
        status = 'finished'
        break
      case 4:
        cardColor = 'warning'
        status = 'finished'
        icon = 'bx-error'
        break
      case 2:
      case 5:
        cardColor = 'danger'
        status = 'finished'
        icon = 'bx-error'
        hasError = true
        break
    }
  } else {
    if (currentSubmitProgress < activateSubmitProgress) {
      cardColor = 'secondary'
    } else if (currentSubmitProgress === activateSubmitProgress) {
      cardColor = 'primary'
      bgJobCanStart = true
    }
  }

  return { status, cardColor, bgJobCanStart, backgroundJobMessages, message, icon, hasError }
}

export { useBackgroundJobCard }



// WEBPACK FOOTER //
// ./src/components/backgroundJobs/useBackgroundJobCard.js